import { DynamicDocumentInstructions } from "@/configuration/document-mappings/types";
import type { StepOutputs } from "@/src/lib/workflows/steps/step-outputs";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export type DocumentManagementInstructionsResponse = {
  instructions: DynamicDocumentInstructions;
  stepOutputs: StepOutputs;
  ccDescription: string | null;
};

export async function getDocumentManagementInstructions(
  taskId: string
): Promise<DocumentManagementInstructionsResponse> {
  return fetchJSON<DocumentManagementInstructionsResponse>(`/api/tasks/${taskId}/document-management-instructions`);
}
